import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loginimg from "../component/login.png";

const LoginPage = ({ setAuthenticated }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  // Check if the user is already authenticated on component mount
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const tokenTimestamp = localStorage.getItem("authTokenTimestamp");

    if (token && tokenTimestamp) {
      const currentTime = Date.now();
      const tokenAge = currentTime - parseInt(tokenTimestamp, 10);

      if (tokenAge < 3600000) {
        // Token is still valid (less than 1 hour old)
        setAuthenticated(true);
        navigate("/admin");
      } else {
        // Token expired, remove it
        localStorage.removeItem("authToken");
        localStorage.removeItem("authTokenTimestamp");
      }
    }
  }, [setAuthenticated, navigate]);

  // Generate a simple token
  const generateToken = () => {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username === "Rosenwell" && password === "@RosenwellAdmin1423") {
      const token = generateToken();
      localStorage.setItem("authToken", token);
      localStorage.setItem("authTokenTimestamp", Date.now().toString()); // Store login time

      setAuthenticated(true);
      navigate("/admin");

      // Set timeout to remove token after 1 hour
      setTimeout(() => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("authTokenTimestamp");
        setAuthenticated(false);
        navigate("/login");
      }, 3600000); // 1 hour = 3600000 ms
    } else {
      setError("Invalid credentials");
    }
  };

  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "20px", color: "#333" }}>
        RosenWell Admin Panel
      </h1>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f4f4f4",
          padding: "20px",
          flexWrap: "wrap",
        }}
      >
        {/* Image Section */}
        <div
          style={{
            flex: 1,
            textAlign: "center",
            maxWidth: "50%",
          }}
        >
          <img
            src={loginimg}
            alt="Login"
            style={{
              maxWidth: "100%",
              height: "auto",
              borderRadius: "10px",
            }}
          />
        </div>

        {/* Login Form Section */}
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "400px",
            width: "100%",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              width: "100%",
            }}
          >
            <h2 style={{ marginBottom: "20px", color: "#333" }}>Login</h2>
            <form
              onSubmit={handleSubmit}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{
                  padding: "10px",
                  marginBottom: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  padding: "10px",
                  marginBottom: "20px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  fontSize: "16px",
                }}
              />
              <button
                type="submit"
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  padding: "10px",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                Login
              </button>
            </form>
            {error && (
              <div
                style={{
                  marginTop: "10px",
                  color: "red",
                  fontSize: "14px",
                }}
              >
                {error}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile-Responsive Styles */}
      <style>
        {`
          @media (max-width: 768px) {
            div[style*="display: flex"] {
              flex-direction: column;
              height: auto;
            }
            div[style*="max-width: 50%"] {
              max-width: 100%;
            }
            div[style*="max-width: 400px"] {
              max-width: 100%;
              padding: 20px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default LoginPage;
